var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invoicing",class:{text_center: _vm.imgUrl}},[(_vm.imgUrl)?_c('img',{attrs:{"src":_vm.imgUrl,"alt":""}}):_c('iframe',{staticStyle:{"width":"100%"},attrs:{"src":_vm.pdfUrl,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }